export default "__VITE_ASSET__CNH4_KBy__"